import React, { Component, createRef } from 'react';
import {
    IonSegment,
    IonContent,
    IonSegmentButton,
    IonLabel,
    IonIcon,
    IonButton,
} from '@ionic/react';
import './index.css';
import { withTranslation } from '../../lib/translate';
import { NormalText } from '../common';

class ScrollTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            heightDifference: 0,
            activeTab: null,
        }
        this.lastTabRef = createRef();
        this.contentRef = createRef()
        this.tabsRef = createRef()
        this.tabsContent = []
    }
    componentWillUnmount() {
        this.props.parent.removeEventListener("scroll", this.handleScroll);
    }
    componentDidMount() {
        setTimeout(() => {
            this.setState({
                heightDifference: this.props.parent.clientHeight - this.lastTabRef.current.clientHeight - 64
            })
            this.tabsContent = Array.from(this.contentRef.current.children);
            this.props.parent.addEventListener("scroll", this.handleScroll)

        }, 100);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.activeTab !== this.state.activeTab && this.state.activeTab) {
            document.querySelector(`#tab_${this.state.activeTab}`).scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }
    handleScroll = () => {
        if (this.tabsRef.current.getBoundingClientRect().top >= 50) {
            this.setState({
                activeTab: null,
            })
            return
        }
        for (let i = 0; i < this.tabsContent.length; i++) {
            if (this.tabsContent[i].getBoundingClientRect().top > 50 && this.tabsContent[i].getBoundingClientRect().top <= 95) {
                this.setState({
                    activeTab: i,
                })
            }
        }

    }
    render() {
        const tabs = this.props.tabs || [];
        return (
            <div className='scrollable-tabs-wrapper' >
                <div ref={this.tabsRef} className='scrollable-tabs-header'>
                    {tabs.map((tab, index) => (
                        <NormalText className={this.state.activeTab == index ? 'scrollable-tabs-button-active' : ''} onClick={() => this.setState({ activeTab: index })} fill='clear'>{tab.title}</NormalText>
                    ))}
                </div>
                <div ref={this.contentRef} style={{ paddingBottom: `${this.state.heightDifference}px` }} className='scrollable-tabs-content'>
                    {tabs.map((tab, index) => (

                        <div id={`tab_${index}`} ref={index + 1 == tabs.length ? this.lastTabRef : null} >{tab.content}</div>
                    ))}
                </div>

            </div>
        );
    }
}

export default withTranslation(ScrollTabs);
